import { organizationSchema, websiteSchema, breadcrumbSchema } from '../components/SEO.jsx'

const SITE_URL = 'https://www.tredextechnology.in'

export const HOME_META = {
  title: 'AI Chatbot & AI Features for Business Websites | TRED-EX AI',
  description: 'TRED-EX AI helps businesses add intelligent AI features to their websites — AI chatbots, smart search, lead qualifiers, multilingual support, and automated SEO. Turn visitors into customers with AI.',
  canonical: '/',
  keywords: 'AI chatbot for business, AI features for websites, smart website AI, lead generation AI, local business AI, 24/7 AI support, AI customer service, TRED-EX AI, website automation, AI for small business',
  structuredData: [organizationSchema, websiteSchema, {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { position: 1, name: 'Home', item: SITE_URL }
    ]
  }]
}

export const SERVICES_META = {
  title: 'AI Services for Websites — AI Features | TRED-EX AI',
  description: 'Explore AI features we install for businesses: AI chatbots, smart search, lead qualifiers, multilingual translation, SEO automation, voice assistant, and more. No rebuild needed.',
  canonical: '/services',
  keywords: 'AI services, AI chatbot installation, smart search, lead qualifier, multilingual website AI, AI SEO, business AI features, AI customer support, TRED-EX AI services',
  structuredData: [organizationSchema, websiteSchema, {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { position: 1, name: 'Home', item: SITE_URL },
      { position: 2, name: 'Services', item: `${SITE_URL}/services` }
    ]
  }]
}

export const PRICING_META = {
  title: 'AI Website Feature Pricing — Starter, Growth, Enterprise | TRED-EX AI',
  description: 'Transparent location-based pricing for AI website features. Starter, Growth, and Enterprise packages for businesses. One-time setup + monthly maintenance. AI chatbot from ₹15,000 / $1,500.',
  canonical: '/pricing',
  keywords: 'AI pricing, chatbot pricing, website AI cost, AI maintenance plan, small business AI packages, TRED-EX AI pricing, AI chatbot cost India',
  structuredData: [organizationSchema, websiteSchema, {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { position: 1, name: 'Home', item: SITE_URL },
      { position: 2, name: 'Pricing', item: `${SITE_URL}/pricing` }
    ]
  }]
}

export const ABOUT_META = {
  title: 'About TRED-EX AI — Democratizing AI for Businesses',
  description: 'We started TRED-EX AI to democratize AI for businesses. No jargon, no enterprise contracts — just practical AI features like AI chatbots and smart search that drive results.',
  canonical: '/about',
  keywords: 'about TRED-EX AI, AI agency, small business AI, AI web development, our story, AI chatbot company India',
  structuredData: [organizationSchema, websiteSchema, {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { position: 1, name: 'Home', item: SITE_URL },
      { position: 2, name: 'About', item: `${SITE_URL}/about` }
    ]
  }]
}

export const IT_SOLUTIONS_META = {
  title: 'IT Solutions & Software Development Services | TRED-EX AI',
  description: 'Discover custom software development services including website development, app development, SEO, site analysis, full website rebuild, e-commerce solutions, and AI feature integration.',
  canonical: '/it-solutions',
  keywords: 'IT solutions, software development, website development, app development, SEO optimization, e-commerce development, AI integration, TRED-EX AI IT',
  structuredData: [organizationSchema, websiteSchema, {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { position: 1, name: 'Home', item: SITE_URL },
      { position: 2, name: 'IT Solutions', item: `${SITE_URL}/it-solutions` }
    ]
  }]
}

export const CONTACT_META = {
  title: 'Contact TRED-EX AI — Free AI Audit & Consultation',
  description: 'Contact TRED-EX AI for a free AI audit of your business website. We respond within 24 hours with practical AI recommendations. Phone: +91 9677255272.',
  canonical: '/contact',
  keywords: 'contact TRED-EX AI, AI audit, AI chatbot consultation, AI website quote, contact India, AI for business, free AI consultation',
  structuredData: [organizationSchema, websiteSchema, {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { position: 1, name: 'Home', item: SITE_URL },
      { position: 2, name: 'Contact', item: `${SITE_URL}/contact` }
    ]
  }]
}

export const BLOG_META = {
  title: 'Blog — AI Insights for Business Websites | TRED-EX AI',
  description: 'Practical guides on adding AI features to your business website — from AI chatbots and smart search to lead generation and SEO automation.',
  canonical: '/blog',
  keywords: 'AI blog, chatbot blog, AI for business, website AI tips, lead generation blog, SEO automation, TRED-EX AI blog',
  structuredData: [organizationSchema, websiteSchema, {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { position: 1, name: 'Home', item: SITE_URL },
      { position: 2, name: 'Blog', item: `${SITE_URL}/blog` }
    ]
  }]
}

export const LEGAL_PAGES = {
  terms: {
    title: 'Terms of Service',
    description: 'Read TRED-EX AI terms of service including acceptable use, subscriptions, payments, cancellation, and service availability policies.',
    url: '/terms'
  },
  privacy: {
    title: 'Privacy Policy',
    description: 'TRED-EX AI privacy policy covering data collection, usage, retention, your rights under Indian law, and security practices.',
    url: '/privacy'
  },
  refund: {
    title: 'Refund Policy',
    description: 'TRED-EX AI refund policy for subscriptions, cancellations, and Razorpay dispute resolution.',
    url: '/refund'
  },
  disclaimer: {
    title: 'Disclaimer',
    description: 'TRED-EX AI disclaimer covering AI-generated content accuracy and liability.',
    url: '/disclaimer'
  },
  cookies: {
    title: 'Cookie Policy',
    description: 'TRED-EX AI cookie policy. Learn about essential cookies, payment processor cookies, and how to manage cookies in your browser.',
    url: '/cookies'
  }
}
